/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

import {
  RideGlRight, RideIcHospitalLight, RideGlSearchSolid, RideGlCloseOutline,
} from '@rimac-seguros/ride-system-components';

import { useResizeRb } from '../../../hooks/useResize';
import { getCoincidenceTokens } from '../../../utils/text.utils';
import MobileClinic from './MobileClinic';
import { modeSearch } from './constants/general';
import { searchPlan } from './service';
import { getTagActionName, getTagMetadata } from '../../../utils/analytics';
import useDebounce from '../../../hooks/useDebounce';

export const COINCIDENCES_COUNT = 1;

export const ItemSuggestion = ({ title, onClick }) => (
  <li>
    <div className="cursor-pointer input-search__suggestion-item" onClick={() => onClick(title)}>
      <div className="input-search__suggestion-icon">
        <RideIcHospitalLight size="small" />
      </div>

      <div className="input-search__suggestion-text">
        <div className="input-search__suggestion-text-label">{title}</div>
        <div className="input-search__suggestion-text-icon">
          <RideGlRight size="medium" />
        </div>
      </div>
    </div>
  </li>
);

export const ItemResult = ({ title, onClick }) => (
  <li>
    <div className="cursor-pointer input-search__result-item" onClick={() => onClick(title)}>
      <i className="input-search__result-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            // eslint-disable-next-line max-len
            d="M21.42 19.83L16.5 14.94C17.4662 13.6607 17.9924 12.1031 18 10.5C18 9.01664 17.5601 7.5666 16.736 6.33323C15.9119 5.09986 14.7406 4.13856 13.3701 3.57091C11.9997 3.00325 10.4917 2.85472 9.03682 3.14411C7.58197 3.4335 6.2456 4.14781 5.1967 5.1967C4.14781 6.2456 3.4335 7.58197 3.14411 9.03683C2.85472 10.4917 3.00325 11.9997 3.57091 13.3701C4.13856 14.7406 5.09986 15.9119 6.33323 16.736C7.5666 17.5601 9.01664 18 10.5 18C12.1031 17.9924 13.6607 17.4662 14.94 16.5L19.83 21.39L21.42 19.83ZM5.25 10.5C5.25 9.46165 5.55791 8.44662 6.13479 7.58326C6.71167 6.7199 7.5316 6.047 8.49092 5.64964C9.45023 5.25228 10.5058 5.14831 11.5242 5.35088C12.5426 5.55345 13.4781 6.05347 14.2123 6.78769C14.9465 7.52192 15.4466 8.45738 15.6491 9.47578C15.8517 10.4942 15.7477 11.5498 15.3504 12.5091C14.953 13.4684 14.2801 14.2883 13.4167 14.8652C12.5534 15.4421 11.5384 15.75 10.5 15.75C9.10762 15.75 7.77226 15.1969 6.78769 14.2123C5.80313 13.2277 5.25 11.8924 5.25 10.5Z"
            fill="#03050F"
          />
        </svg>
      </i>
      <div className="input-search__result-text">
        <span dangerouslySetInnerHTML={{ __html: title }} />
      </div>
    </div>
  </li>
);

export const NoResult = ({ text }) => (
  <>
    <span className="input-search__result-no-text">
      No se hallaron resultados para
      {' '}
      <b>
        "
        {text}
        "
      </b>
    </span>
    <div className="input-search__result-no-data">
      <div>Sugerencias</div>
      <ul>
        <li>Asegúrase de que todas las palabras estén escritas correctamente.</li>
        <li>Prueba diferentes palabras.</li>
        <li>Prueba menos palabras.</li>
      </ul>
    </div>
  </>
);

export const InputSearch = ({
  onFilterPlan, onFilterPlanMobile, placeholder, suggestions = [], clinicsData = [],
}) => {
  const [textMatch, setTextMatch] = useState('');
  const [showSuggestion, setShowSuggestion] = useState(false);
  const [showCoincidence, setShowCoincidence] = useState(false);
  const [clinicMobile, setClinicMobile] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [activeMobile, setActiveMobile] = useState(false);
  const [coincidence, setCoincidence] = useState([]);
  const idInputSearch = 'inputSearch';
  const minCharacterMatch = 3;

  const checkMobile = () => {
    const currentWidth = window.innerWidth;
    const yesMobile = currentWidth <= 600;
    setIsMobile(yesMobile);
    if (!yesMobile) {
      setTextMatch('');
      setClinicMobile({ show: false });
      setActiveMobile(false);
      setShowSuggestion(false);
    }
  };

  useResizeRb(checkMobile);

  const onResetSearch = () => {
    setTextMatch('');
    setActiveMobile(false);
    setShowSuggestion(false);
    setCoincidence([]);

    if (isMobile) {
      onFilterPlanMobile(modeSearch.reset);
    } else {
      onFilterPlan([], modeSearch.reset);
    }
  };

  const debouncedGetTagMetadata = useDebounce((value, resultType) => {
    getTagMetadata('Seguro Salud Flexible – Buscador de clínicas', `${resultType} - ${value}`, 'trackMetadata');
  }, 300);

  const onChangeTextMatch = async (e) => {
    const value = (e.target.value || '').replaceAll(/\s+/gi, ' ');
    setTextMatch(value);
    if (value.length >= minCharacterMatch) {
      const clinicsFilter = clinicsData
        .map((clinic) => {
          const tokens = getCoincidenceTokens(clinic.search, value, {
            coincidencesCount: COINCIDENCES_COUNT,
            ignoreAccents: true,
          });
          return {
            ...clinic,
            tokens,
            displayLabel: tokens.map(({ type, word }) => (type === 'coincidence' ? `<b>${word}</b>` : word)).join(''),
          };
        })
        .filter((item) => item.tokens.length > 1);
      const resultType = clinicsFilter.length ? 'Con resultado' : 'Sin resultado';
      debouncedGetTagMetadata(value, resultType);
      setCoincidence(clinicsFilter);
      setShowSuggestion(false);
      setShowCoincidence(true);
    } else if (!showSuggestion) {
      setCoincidence([]);
      setShowSuggestion(true);
      setShowCoincidence(false);
    }
  };

  const onClickText = (e) => {
    e.stopPropagation();
    if (textMatch.length >= minCharacterMatch) {
      setShowCoincidence(true);
    } else {
      setShowSuggestion(true);
    }
    if (isMobile) {
      setActiveMobile(true);
    }
  };

  const onClickSuggestion = async (exactTextMatch) => {
    const clinic = await searchPlan(clinicsData, exactTextMatch, 'other');
    getTagActionName('Seguro Salud Flexible', 'Modal - Lista de clínicas', 'Clínicas más buscadas', exactTextMatch, 'trackAction');

    if (isMobile) {
      setClinicMobile({
        show: true,
        ...clinic[0],
        price: '40',
      });
      onFilterPlanMobile(modeSearch.change);
    } else if (clinic) {
      onFilterPlan(clinic, modeSearch.change);
    }
  };

  const onClickResult = async (clinic) => {
    getTagActionName('Seguro Salud Flexible', 'Modal - Lista de clínicas', 'Resultado de búsqueda', clinic.search, 'trackAction');

    if (isMobile) {
      setClinicMobile({
        show: true,
        ...clinic,
        price: '40',
      });
      onFilterPlanMobile(modeSearch.change);
    } else if (clinic) {
      onFilterPlan([clinic], modeSearch.change);
    }
  };

  function onBlur(e) {
    if (idInputSearch !== e.target.id) {
      setShowSuggestion(false);
      setShowCoincidence(false);
    }
  }

  useEffect(() => {
    if (textMatch !== '') {
      setTextMatch('');
    }

    if (!isMobile) {
      document.addEventListener('click', onBlur);
    }
    return () => {
      document.removeEventListener('click', onBlur);
    };
  }, [idInputSearch, isMobile]);

  useEffect(() => {
    checkMobile();
  }, []);

  return (
    <div className={`input-search${activeMobile ? ' input-search--mobile' : ''}`}>
      <div className="input-search--absolute">
        <div className="form-group search-dropdown">
          <i className={`search-input-icon search-input-icon--left${activeMobile ? ' search-input-icon--mobile' : ''}`}>
            <RideGlSearchSolid />
          </i>

          <input
            type="text"
            id={idInputSearch}
            value={textMatch}
            onChange={(e) => onChangeTextMatch(e)}
            onClick={(e) => onClickText(e)}
            placeholder={placeholder}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            autoComplete="off"
            className={activeMobile ? ' input-search-field--mobile' : ''}
          />
          <i className="search-input-icon">
            {showSuggestion || Boolean(textMatch) ? (
              <div onClick={() => onResetSearch()}>
                <RideGlCloseOutline size="x-large" />
              </div>
            ) : (
              <RideGlSearchSolid />
            )}
          </i>
          {showSuggestion && suggestions.length ? (
            <div className="input-search__suggestion">
              <h4>Clínicas más buscadas</h4>
              <ul>
                {suggestions.map((item, key) => (
                  <ItemSuggestion key={key} title={item} onClick={onClickSuggestion} />
                ))}
              </ul>
            </div>
          ) : null}
          {showCoincidence && coincidence.length ? (
            <div className="input-search__result custom-scroll">
              <h4>resultado de búsqueda</h4>
              <ul>
                {coincidence.map((item, key) => (
                  <ItemResult key={key} title={item.displayLabel} onClick={() => onClickResult(item)} />
                ))}
              </ul>
            </div>
          ) : (
            showCoincidence
            && textMatch.length >= minCharacterMatch && (
              <div className="input-search__result">
                <NoResult text={textMatch} />
              </div>
            )
          )}
        </div>
      </div>
      {clinicMobile.show && (
        <MobileClinic
          plan={clinicMobile?.planData?.title}
          title={clinicMobile?.label}
          price={clinicMobile?.price}
          location={clinicMobile?.name}
          setPopupActivo={() => setClinicMobile({ show: false })}
          setInteractionCall={() => {}}
          isMobil
        />
      )}
    </div>
  );
};
